<h1>{{titulo}}</h1>
<h3>La base es <strong>{{base}}</strong></h3>
<button (click)='acumular(-base)'>-1</button>

{{acumulador}}

<button (click)='acumular(base)'>+1</button>